module.exports = __webpack_public_path__ + "img/Skiing006.7ce1dc61.jpg";